import { fadeOut, containEvent } from "../droom/utilities"

// Unlike the image picker this is just a simple input-handler
// with some optional file type checking. Form submission continues
// as normal once the submit button has been enabled and clicked.

class FilePicker {
  constructor(el, opts={}) {
    this.container = el;
    this.label = el.querySelector('label');
    this.field = el.querySelector('input[type="file"]');
    this.datafield = el.querySelector('input[data-role=data]');
    this.pre = el.querySelector('pre');
    this.stumbit = el.querySelector('input[type="submit"]');
    this.requirement = opts.require || 'csv';
    this.warning = el.querySelector('.warning');
    this.complaint = "";

    this.container.addEventListener('dragenter', this.dragEnter.bind(this), false)
    this.container.addEventListener('dragleave', this.dragLeave.bind(this), false)
    this.container.addEventListener('dragover', this.dragOver.bind(this), false)
    this.container.addEventListener('drop', this.dropFile.bind(this), false)
    this.field.addEventListener('input', this.pickFile.bind(this), false)

    this.showUnready();
  }

  pickFile(e) {
    const file = this.field.files[0];
    if (this.checkFile(this.field.files[0])) {
      const reader = new FileReader();
      const readFile = () => {
        this.pre.innerText = reader.result;
        this.showReady();
      };
      reader.addEventListener('load', readFile.bind(this));
      reader.readAsText(file);
    } else {
      this.warn();
    }
  }

  dropFile(e) {
    unbubble(e);
    const transferItem = e.dataTransfer.items[0];
    if (transferItem) {
      const file = transferItem.getAsFile();
      if (file && this.checkFile(file)) {
        const reader = new FileReader();
        const readFile = () => {
          this.datafield.value = reader.result;
          this.pre.innerText = reader.result;
          this.showReady();
        };
        reader.addEventListener('load', readFile.bind(this));
        reader.readAsText(file);
      } else {
        this.warn();
      }
    }
  }

  checkFile(file) {
    if (!file) {
      return false
    }
    if (file.size > 1000000) {
      this.complaint = "File is too large! Maximum size is 1MB"
      return false;
    }
    if (file.type != 'text/csv') {
      this.complaint = "Please choose a CSV file";
      return false;
    }
    this.complaint = "";
    return true;
  }

  warn() {
    if (this.warning_timer) {
      window.clearTimeout(this.warning_timer);
    }
    if (this.complaint) {
      this.warning.innerText = this.complaint;
      this.container.classList.add("erratic");
      this.warning_timer = window.setTimeout(this.unwarn.bind(this), 1000)
    }
  }

  unwarn() {
    if (this.warning_timer) {
      window.clearTimeout(this.warning_timer);
    }
    this.container.classList.remove("erratic");
  }

  dragEnter(e) {
    unbubble(e);
    this.checkPayload(e);
  }

  dragLeave(e) {
    unbubble(e);
    this.showNormal();
  }

  dragOver(e) {
    unbubble(e);
    this.checkPayload(e);
  }

  checkPayload(e) {
    const file = e.dataTransfer.items[0];
    if (file && this.checkFile(file)) {
      this.showWilling();
      return true;
    }
    this.showNormal();
    return false;
  }

  showReady() {
    this.container.classList.add('ready');
    this.container.classList.remove('unready');
    this.container.classList.remove('droppable');
    this.container.classList.remove('undroppable');
  }

  showUnready() {
    this.container.classList.remove('ready');
    this.container.classList.add('unready');
  }

  showWilling() {
    this.container.classList.remove('undroppable');
    this.container.classList.add('droppable');
  }

  showUnwilling() {
    this.container.classList.add('undroppable');
    this.container.classList.remove('droppable');
  }

  showNormal() {
    this.container.classList.remove('undroppable');
    this.container.classList.remove('droppable');
  }
}

function unbubble(e) {
  e.preventDefault();
  e.stopPropagation();
}

function fileIsImage(file) {
  return file && (!file.type || /^image/.test(file.type));
}

function fileIsPdf(file) {
  return file && (!file.type || /pdf/.test(file.type));
}

function fileIsImageOrPdf(file) {
  return fileIsImage(file) || fileIsPdf(file)
}

function csvFilePicker(el) {
  return new FilePicker(el, {require: "csv"});
}

function filePicker(el) {
  return new FilePicker(el, {});
}

export {
  filePicker,
  csvFilePicker,
};